import {
    addToSelection,
    clearSelection,
    removeFromSelection,
} from '../reducers';

import {selectionSelector} from '../selectors';
import {
    useAppDispatch,
    useAppSelector
} from '../../../hooks/useTypedReactRedux';
import {Persona} from "../types.ts";


export const usePersonasSelection = () => {
    const dispatch = useAppDispatch();

    const selection = useAppSelector((state) => selectionSelector(state));

    // FNP-950: `items` used to come from the records slice, which nothing
    // populated - so handleSelectAllRows below looped over an empty array and
    // silently did nothing. It has zero consumers (the tables use
    // MantineDataTable's own onSelectedRecordsChange), so rather than wire it
    // to React Query for a caller that does not exist, it takes the rows it
    // should act on as an argument.


    // SELECTION
    const handleRowSelection = (row: Persona) => {
        if (typeof selection[row.id] !== 'undefined') {
            dispatch(removeFromSelection(row.id));
        } else {
            dispatch(addToSelection(row));
        }
    };

    const handleSelectAllRows = (items: { id: string }[]) => {
        for (let i = 0; i < items.length; i++) {
            if (typeof selection[items[i].id] !== 'undefined') {
                dispatch(removeFromSelection(items[i].id));
            } else {
                dispatch(addToSelection(items[i]));
            }
        }
    };

    const handleClearSelection = () => {
        dispatch(clearSelection());
    };

    return {
        selection,
        handleRowSelection,
        handleSelectAllRows,
        handleClearSelection,
    };
};
